// The hub's yes or no question, asked in its own dialog (components/ConfirmDialog.js) rather than
// the browser's. The page carries on while it is open, so await the answer.
let show = null;

export const dialog = {
  /**
   * Resolves true if they confirmed. { title, body, confirmLabel, danger }: the question, the rest
   * of what they should know, the words on the button that does it, and whether that button should
   * look dangerous. With nothing mounted to ask, the answer is no.
   */
  confirm: (options) =>
    new Promise((resolve) => {
      if (!show) {
        resolve(false);
        return;
      }
      show({ ...options, resolve });
    }),
};

/** For the mounted dialog. Returns the way to stop. */
export function registerConfirmDialog(showDialog) {
  show = showDialog;
  return () => {
    if (show === showDialog) show = null;
  };
}
